import React, { useState, useEffect } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import LinearProgress from '@mui/material/LinearProgress';
import { IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { IUnidEntityResponse } from '../../../../model/scp/entity/response/unid-entity-response';
import EntityAppService from '../../../../application/platform/scp/entity/entitiy-app-service';
import { dataGridLocaleConfig } from '../../../../config/data-grid-locale';

export default function UnidEntityDataTable({ props }: { props: {} }) {
    const [response, setResponse] = useState<IUnidEntityResponse[]>([]);
    const [loadMoreData, setLoadMoreData] = useState(true);

    const loadData = () => {
        (async () => {
            setLoadMoreData(true);
            const data = await EntityAppService.listUnidEntity();
            setResponse(data);
            setLoadMoreData(false);
        })();
    }

    const columns: GridColDef<IUnidEntityResponse>[] = [
        { field: 'id', headerName: 'Id', width: 90, hide: true },
        {
            field: 'unitCode',
            headerName: 'Código',
            minWidth: 100
        },
        {
            field: 'name',
            headerName: 'Nome',
            flex: 1,
            minWidth: 220
        }
    ];

    useEffect(() => {
        loadData();
    }, []);

    return (<React.Fragment>
        <DataGrid
            rows={response}
            columns={columns}
            rowCount={response.length}
            disableSelectionOnClick

            paginationMode="server"
            components={{
                LoadingOverlay: LinearProgress,
            }}
            loading={loadMoreData}
            hideFooterPagination={true}
            rowsPerPageOptions={[]}
            experimentalFeatures={{ newEditingApi: true }}
            localeText={dataGridLocaleConfig}
        />
    </React.Fragment>
    )
}